module.exports = __webpack_public_path__ + "img/formal-1.8610258b.jpg";